export default __webpack_public_path__ + "static/media/loginLogo.401d1d93.png";